<mat-card *ngIf="!isEditMode">
  <mat-card-content>
    <div class="survey-container">
      <mat-label>Enter with an username</mat-label>
      <mat-form-field class="form-field" appearance="standard">
        <input
          matInput
          color="primary"
          id="username"
          type="text"
          name="username"
          [(ngModel)]="username"
          class=""
          placeholder="Username"
          required
          minlength="4"
        />
      </mat-form-field>
      <div>
        <div *ngIf="submitted">
          <div *ngIf="!isUsername(username)" class="color-danger">
            This field is required
          </div>
        </div>
        <br />
        <div class="form-group">
          <ng-select
            [multiple]="true"
            [(ngModel)]="institutionIds"
            placeholder="Search by institution(s) *"
          >
            <ng-option
              *ngFor="let inst of institutions"
              [value]="inst.id"
              required
            >
              {{ inst.description }}
            </ng-option>
          </ng-select>
        </div>
        <div *ngIf="submitted">
          <div *ngIf="!hasInstitutions(institutionIds)" class="color-danger">
            You must select at least one
          </div>
        </div>
      </div>
    </div>
  </mat-card-content>
</mat-card>
<mat-card>
  <mat-card-content>
    <h5 class="color-primary">{{ "Survey" | translate }}</h5>
    <br />
    <div class="survey-container">
      <div class="content">
        <form
          *ngIf="questions.length > 0"
          (ngSubmit)="onSubmit()"
          [formGroup]="form"
          class="form"
        >
          <div *ngFor="let question of questions">
            <app-survey-question
              [question]="question"
              [form]="form"
              [submitted]="submitted"
            >
            </app-survey-question>
            <br />
          </div>
          <div>
            <label>(*) This field is required</label>
          </div>
          <br />
          <button
            mat-flat-button
            color="primary"
            type="submit"
            [disabled]="isLoading"
          >
            <span *ngIf="isLoading" class="spinner-border"></span>
            {{ "Save" | translate }}
          </button>
        </form>
      </div>
    </div>
  </mat-card-content>
</mat-card>
